import cx from 'classnames';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import {
  selectHasEnded,
  selectPlaying,
  selectSeeking,
  selectShowingComments,
  selectTheaterMode,
  suppressPlayAnimation,
} from 'selectors/videoPlayer';

import SvgPause from 'img/video-player/pause_overlay.svg';
import SvgPlay from 'img/video-player/play_overlay.svg';

import styles from './styles.module.less';

const PlayPauseOverlay = () => {
  const playing = useSelector(selectPlaying);
  const inTheaterMode = useSelector(selectTheaterMode);

  const hasEnded = useSelector(selectHasEnded);
  const showingAllComments = useSelector(selectShowingComments);
  const suppressAnimations = useSelector(suppressPlayAnimation);
  const seeking = useSelector(selectSeeking);

  const [animatePlay, setAnimatePlay] = useState(false);
  const [animatePause, setAnimatePause] = useState(false);

  const [prevPlaying, setPrevPlaying] = useState(playing);

  useEffect(() => {
    if (playing != prevPlaying) {
      const showPlayAnimation = playing && !suppressAnimations && !seeking;
      const showPauseAnimation =
        !playing &&
        !hasEnded &&
        !showingAllComments &&
        !seeking &&
        !suppressAnimations;

      setAnimatePlay(showPlayAnimation);
      setAnimatePause(showPauseAnimation);

      setPrevPlaying(playing);
    }
  }, [
    hasEnded,
    playing,
    prevPlaying,
    seeking,
    showingAllComments,
    suppressAnimations,
  ]);

  useEffect(() => {
    // cut off animation early if we enter/exit theater mode,
    // otherwise it would reset
    setAnimatePlay(false);
    setAnimatePause(false);
  }, [inTheaterMode]);

  return (
    <div className={styles.playPauseOverlay}>
      <img
        onAnimationEnd={() => {
          setAnimatePlay(false);
        }}
        className={cx(styles.playPauseIcon, { [styles.animate]: animatePlay })}
        src={SvgPlay}
      />
      <img
        onAnimationEnd={() => {
          setAnimatePause(false);
        }}
        className={cx(styles.playPauseIcon, { [styles.animate]: animatePause })}
        src={SvgPause}
      />
    </div>
  );
};

export default PlayPauseOverlay;
